import { createSlice } from "@reduxjs/toolkit";
import { DropdownsInfo } from "../../types/clients-module-types";
import { loadClientProfileDropdownInfo } from "../../utils/clientsUtils";

type ClientDropdownsState = {
  isLoadingDropdownInfo: boolean;
  dropdownsInfo: DropdownsInfo | null;
};

const initialState: ClientDropdownsState = {
  isLoadingDropdownInfo: false,
  dropdownsInfo: null,
};

export const clientDropdownsSlice = createSlice({
  name: "clientDropdowns",
  initialState,
  reducers: {
    loadDropdownInfo: (state, action) => {
      state.dropdownsInfo = loadClientProfileDropdownInfo(action.payload);
      state.isLoadingDropdownInfo = false;
    },
    setIsLoadingDropdownInfo: (state, action) => {
      state.isLoadingDropdownInfo = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadDropdownInfo, setIsLoadingDropdownInfo } =
  clientDropdownsSlice.actions;

export const IsLoadingDropdownInfo = (state: any) => {
  return state.clientDropdowns.isLoadingDropdownInfo;
};

export const SelectDropdownsInfo = (state: any) => {
  return state.clientDropdowns.dropdownsInfo;
};

export default clientDropdownsSlice.reducer;
